import { colors, colorsBankee } from "../../themes/palette/colors"

export const getColorApp = (CE: string, BKZ: string): string =>
  process.env.REACT_APP_TYPE === "classequity" ? CE : BKZ

export const getMockupColor = (CE: typeof colors, BKZ: typeof colorsBankee) =>
  process.env.REACT_APP_TYPE === "classequity" ? CE : BKZ
